import Icon from '../Icon.vue'

Icon.register({
  'download': {
    width: 11,
    height: 12,
    paths: [
      {
        d: 'M9.643 12h-9A.641.641 0 010 11.357v-.643c0-.356.287-.643.643-.643h9c.356 0 .643.287.643.643v.643a.641.641 0 01-.643.643zM3.429.643v3.643h-2.35a.535.535 0 00-.377.913l4.077 4.077c.2.2.53.2.73 0l4.078-4.077a.535.535 0 00-.378-.913H6.857V.643A.641.641 0 006.214 0H4.071a.641.641 0 00-.642.643z'
      }
    ]
  }
})
